import React from "react";
import CabezaPagina from "./components/cabezaPagina/CabezaPagina";
import Navbar from "./components/navbar/Navbar"
import About from "./components/about/About"
import Experiencia from "./components/experiencia/Experiencia"
import Servicios from "./components/servicios/Servicios"
import Portafolio from "./components/portafolio/Portafolio"
import Testimonios from "./components/testimonios/Testimonios"
import Contacto from "./components/contacto/Contacto"
import PiePagina from "./components/piePagina/PiePagina"


const App = () => {
  return (
    <>        
        <CabezaPagina />
        
        <Navbar />
        <About />
        <Experiencia />
        <Servicios />
        <Portafolio />
        
        <Contacto />
    </>
  )
}

export default App